import { makeStyles } from '../../../styles';
import { ROW_SIZE_PIXELS } from './AggregateDropdown.constants';
export default makeStyles((theme) => {
    const commonListItemStyles = {
        cursor: 'pointer',
        padding: theme.spacing(1),
        borderRadius: theme.spacing(1),
        '&:hover': {
            backgroundColor: theme.colors.gray[100],
        },
    };
    return {
        root: {},
        button: {
            padding: theme.spacing(1, 2),
            color: theme.colors.text[900],
            border: `1px solid ${theme.colors.gray[200]}`,
        },
        activeButton: {
            borderColor: theme.colors.primary.main,
        },
        buttonContainer: {},
        buttonContent: {
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(1),
            color: theme.colors.text[600],
        },
        buttonContentLabel: {
            fontWeight: 600,
            textTransform: 'capitalize',
        },
        buttonContentAll: {
            fontWeight: 400,
        },
        buttonContentNone: {
            fontWeight: 400,
        },
        buttonContentValues: {
            color: theme.colors.primary.main,
            fontWeight: 400,
        },
        menu: {},
        menuPaper: {
            marginTop: theme.spacing(0.5),
            boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.08)',
            borderRadius: 8,
            overflow: 'visible',
        },
        menuContent: Object.assign(Object.assign({}, theme.typography.body2), { padding: theme.spacing(0, 1) }),
        divider: {
            margin: theme.spacing(1),
            borderStyle: 'dashed',
        },
        createOption: Object.assign(Object.assign({}, commonListItemStyles), { padding: theme.spacing(1, 1.5) }),
        selectAll: Object.assign(Object.assign({}, commonListItemStyles), { display: 'flex', gap: theme.spacing(1), alignItems: 'center' }),
        listItem: Object.assign(Object.assign({}, commonListItemStyles), { display: 'flex', gap: theme.spacing(1), alignItems: 'center', padding: theme.spacing(0, 1), width: 'calc(100% - 16px) !important' }),
        listDivider: {
            display: 'flex',
            flexDirection: 'column',
            paddingTop: ROW_SIZE_PIXELS / 2,
        },
        checkbox: {
            padding: 0,
        },
        checkboxLabel: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    };
});
//# sourceMappingURL=AggregateDropdown.styles.js.map